module.exports = __webpack_public_path__ + "static/success-e32df48ccaf42d8109052c160e858b57.mp3";